module.exports = __webpack_public_path__ + "media/images/sprite.@2x-821e8ca57b634f21354ea249c4960339.png";